export default "__VITE_ASSET__Bd6sajT3__"